import React from 'react';
import { Facebook, Instagram, Mail, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-blue-600 text-white py-6">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-sm">© {new Date().getFullYear()} Zamintech. Todos los derechos reservados.</p>

        <div className="flex items-center gap-4">
          <a href="https://www.facebook.com/profile.php?id=61553076375062" aria-label="Facebook"><Facebook className="hover:text-gray-200" /></a>
          {/* <a href="#" aria-label="Instagram"><Instagram className="hover:text-gray-200" /></a>
          <a href="#" aria-label="Twitter"><Twitter className="hover:text-gray-200" /></a> */}
          <a href="mailto:estefangz@gmail.com" aria-label="Email"><Mail className="hover:text-gray-200" /></a>
        </div>
      </div>
    </footer>
  );
}
